import { render } from "./StepObjects.vue?vue&type=template&id=574ab5bf&scoped=true"
import script from "./StepObjects.vue?vue&type=script&lang=js"
export * from "./StepObjects.vue?vue&type=script&lang=js"

import "./StepObjects.vue?vue&type=style&index=0&id=574ab5bf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574ab5bf"]])

export default __exports__